import OptionsList from "./index";

export function LocalOptionsList({ question, details, state, dispatch }) {
	return (
		<OptionsList
			question={question}
			details={details}
			state={state}
			dispatch={dispatch}
		/>
	);
}
